import React, { Component } from 'react';
import { GridRow, GridColumn } from '@react/react-spectrum/Grid';
import { Field } from 'redux-form';
import { Translate } from 'react-redux-i18n';

const Item = props => {
        

        return <span>{ props.item.displayLabel ? 
                        props.item.displayLabel[props.input.value] : Array.isArray(props.input.value) ? props.input.value.join(", ") : props.input.value
                        }
                </span>

}

const DataDisplay = props => {
        return <GridRow {...props.item.gridRowProps}>
                        <GridColumn {...props.item.gridColumnProps}>
                                <span > {props.item.label_lang ? <Translate value={props.form+"."+ props.item.label_lang } /> : props.item.label}</span>
                                </GridColumn>
                                <GridColumn {...props.item.gridColumnProps}>
                                <Field name={props.item.name} 
                                item={props.item} component={Item} />
                                                
                        </GridColumn>
                </GridRow>

}
export default DataDisplay;

